import { Input } from "@/components/ui/input";
import { Field, fieldInputCls } from "@/components/Field";
import { useT } from "@/lib/i18n";
import { gearRatio } from "@/lib/format";

export const SetupGroup = ({ fields, prefix, values, onChange, section }) => {
  const { t } = useT();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {fields.map((f) => (
        <Field key={f} label={t(`${prefix}_${f}`)}>
          <Input data-testid={`${section}-${f}-input`} value={values[f] ?? ""} onChange={(e) => onChange({ ...values, [f]: e.target.value })} className={fieldInputCls} />
        </Field>
      ))}
    </div>
  );
};

export const GearFields = ({ values, onChange }) => {
  const { t } = useT();
  const ratio = gearRatio(values.sprocket, values.pinion);
  const set = (k) => (e) => onChange({ ...values, [k]: e.target.value });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
      <Field label={t("sprocket")}>
        <Input data-testid="gear-sprocket-input" type="number" inputMode="numeric" value={values.sprocket} onChange={set("sprocket")} className={fieldInputCls} />
      </Field>
      <Field label={t("pinion")}>
        <Input data-testid="gear-pinion-input" type="number" inputMode="numeric" value={values.pinion} onChange={set("pinion")} className={fieldInputCls} />
      </Field>
      <div className="bg-[#090A0F] border border-[#282D3D] rounded-sm h-10 px-4 flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-wider text-slate-400">{t("ratio")}</span>
        <span data-testid="gear-ratio-value" className="font-mono font-bold text-[#FFB800]">
          {values.sprocket && values.pinion ? `${values.pinion}/${values.sprocket}` : "—"}{ratio ? ` · ${ratio}` : ""}
        </span>
      </div>
    </div>
  );
};
